export default __webpack_public_path__ + "static/media/Q22022.e83eb32f.PDF";